import Axios from 'axios';
import enums from '@/constants/enum';

const instance = Axios.create({
    baseURL: `${feConfig.api.base}`,
    timeout: `${feConfig.api.timeout}`,
    withCredentials: true
});

instance.interceptors.request.use(function(config) {
    if (config.params && config.params.cookieStr) {
        console.log(config, 'config.........');
        document.cookie = config.params.cookieStr;
        delete config.params.cookieStr;
    }
    return config;
});

instance.interceptors.response.use(
    function(response) {
        if (response && enums.ErrorCode.CookieInvalid === response.data.code) {
            // 如果是移动端，cookie失效后触发InvalidCookie事件
            if (window.androidTest) {
                window.androidTest.InvalidCookie();
            }
            if (window.webkit) {
                window.webkit.messageHandlers.InvalidCookie.postMessage(null);
            }
            // 清空cookie值
            let d = new Date();
            d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
            document.cookie = `${feConfig.cookie.key}= ;domain=${feConfig.cookie.domain};expires=${d.toUTCString()}`;
            location.href = '/';
        }
        return response.data;
    },
    function(err) {
        if (err.response) {
            return Promise.reject(err.response.data);
        }
        return Promise.reject({ code: 1024, message: err.message });
    }
);

function axios(options) {
    let cookie = null;
    if (options.cookie) {
        cookie = `${options.cookie.key}=${options.cookie.value}`;
        delete options.cookie;
    }
    const instance = Axios.create(
        Object.assign({
            timeout: `${feConfig.api.timeout}`
        },
        options,
        cookie ? { headers: { Cookie: cookie } } : {}
        )
    );
    instance.interceptors.response.use(
        function(response) {
            return response.data;
        },
        function(err) {
            if (err.response) {
                return Promise.reject(err.response.data);
            }
            return Promise.reject({ code: 1024, message: err.message });
        }
    );
    return instance;
}

function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Vue.http = instance;
    Vue.axios = axios;
    Object.defineProperty(Vue.prototype, '$http', { value: instance });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

export default plugin;



// WEBPACK FOOTER //
// ./src/assets/plugin/axios.js